export const colors = {
  white: '#ffffff',
  primary: '#9C7B2A',
  secondary: '#3E5E75',
};
